import { Component, Vue, Watch } from 'vue-property-decorator';
import './alert-message.component.scss';
import { namespace } from 'vuex-class';
import AppConstants from '@/common/constants/app.constants';
import FlashMessage from '../flash-message.component';
import store from '@/common/store/index';

const AlertMessageStore = namespace('AlertMessageStore');

@Component({})
export default class AlertMessageComponent extends Vue {
  showAlertErrorMessage = true;
  dismissSecs = 5;
  dismissCountDown = 0;
  hiddenSuccessMsgClass = '';
  hiddenErrorMsgClass = '';
  showErrorMsgDetailButton = false;
  heightMessageBox = 0;

  @AlertMessageStore.Getter
  errorMessageArray!: Array<string>;

  @AlertMessageStore.Getter
  successMessageArray!: Array<string>;

  @AlertMessageStore.Action
  removeAllSuccessMessagesFromList!: () => void;

  @AlertMessageStore.Action
  removeMessageFromErrorList!: (msg: string) => void;

  mounted() {
    // アラートコンポーネントの初期化時に高さメッセージを取得します。
    if (this.errorMessageArray.length > 0) {
      this.heightMessageBox = this.getHeightOfMessage(this.errorMessageArray[0]);
    }
    this.hiddenSuccessMsgClass = '';
    this.hiddenErrorMsgClass = '';
  }

  @Watch('successMessageArray')
  onChangeSuccessMessage(): void {
    this.dismissCountDown = this.dismissSecs;
    if (this.successMessageArray.length > 0) {
      this.heightMessageBox = this.getHeightOfMessage(this.successMessageArray[0]);
      this.hiddenSuccessMsgClass = 'animated-success-msg-container';
    }
  }

  @Watch('errorMessageArray')
  onChangeErrorMessage(): void {
    this.showErrorMsgDetailButton = false;
    if (this.errorMessageArray.length > 0) {
      this.heightMessageBox = this.getHeightOfMessage(this.errorMessageArray[0]);
      this.removeAllSuccessMessagesFromList();
      this.hiddenErrorMsgClass = 'animated-error-msg-container';
      window.addEventListener('resize', this.resizeWindow);
      // レンダリングされたメッセージの遅延
      setTimeout(() => {
        this.checkShowDetailButton();
      }, 100);
    } else {
      window.removeEventListener('resize', this.resizeWindow);
    }
  }

  handleCloseErrorMessage(msg: string) {
    this.hiddenErrorMsgClass = 'animated-error-msg-container';
    this.showErrorMsgDetailButton = false;
    this.removeMessageFromErrorList(msg);
  }

  countDownChanged(dismissCountDown: number) {
    this.dismissCountDown = dismissCountDown;
  }

  dismissed() {
    this.dismissCountDown === 0;
    this.removeAllSuccessMessagesFromList();
  }

  get networkConnectionMode() {
    return store.getters.getNetworkConnectionMode;
  }

  /**
   * エラーメッセージの詳細ボタンを表示
   */
  handleShowErrorMsgDetailButton() {
    this.$bvModal.show(AppConstants.DETAIL_ERROR_MESSAGE_ID_MODAL);
  }

  /**
   * メッセージの高さを取得
   *
   * @param    msg      メッセージ
   * @returns {number}  メッセージの高さ
   */
  getHeightOfMessage(msg: string) {
    return FlashMessage.getInstance().getHeightOfMessage(msg);
  }

  /**
   * ウィンドウのサイズ変更
   */
  resizeWindow() {
    this.heightMessageBox = this.getHeightOfMessage(this.errorMessageArray[0]);
    this.checkShowDetailButton();
  }

  /**
   * 詳細ボタンをチェックして表示
   */
  checkShowDetailButton() {
    const elementMessage = document.getElementById('id-error-message');
    if (elementMessage && elementMessage.clientHeight < elementMessage.scrollHeight) {
      this.showErrorMsgDetailButton = true;
    } else {
      this.showErrorMsgDetailButton = false;
    }
  }

  /**
   * メッセージ表示を確認する。
   * @return {boolean} {true: 有効、false: 無効}
   */
  get isMsgShown(): boolean {
    return this.successMessageArray.length > 0 || this.errorMessageArray.length > 0;
  }
  render() {
    return (
      <div
        id="alert-message-block"
        class={{
          'position-relative px-1': true,
          'mt-1': this.isMsgShown,
          'msg-container-border': this.$store.getters?.getModalMode && this.isMsgShown
        }}
      >
        <div
          class={this.successMessageArray.length > 0 ? 'success-msg-container' : this.hiddenSuccessMsgClass}
          style={`--messageHeight: ${this.heightMessageBox}px`}
        >
          <transition-group name="slide">
            {this.successMessageArray.map((item, index) => {
              return (
                <div class="success-msg-box" key={index}>
                  <b-alert
                    show={this.dismissCountDown}
                    variant="success"
                    on-dismissed={() => {
                      this.dismissed();
                    }}
                    on-dismiss-count-down={this.countDownChanged}
                  >
                    <i class="material-icons check-circle">check_circle</i>
                    <span class="ellipsis-message">{item}</span>
                  </b-alert>
                </div>
              );
            })}
          </transition-group>
        </div>
        <div
          class={this.errorMessageArray.length > 0 ? 'error-msg-container' : this.hiddenErrorMsgClass}
          style={`--messageHeight: ${this.heightMessageBox}px`}
        >
          <transition-group name="slide">
            {this.errorMessageArray.map((item, index) => {
              return (
                <div key={index} class={{ 'error-msg-box': true }}>
                  <b-alert show={this.showAlertErrorMessage} variant="danger" key={index}>
                    <i class="material-icons report">report</i>
                    <span class="ellipsis-message" id="id-error-message">
                      {item}
                    </span>
                    {this.showErrorMsgDetailButton && (
                      <span
                        onClick={() => {
                          this.handleShowErrorMsgDetailButton();
                        }}
                        class="btn-detail-error-message"
                      >
                        詳細
                      </span>
                    )}
                    {this.networkConnectionMode && (
                      <i
                        class="material-icons close-message ml-auto cursor-pointer"
                        onClick={() => {
                          this.handleCloseErrorMessage(item);
                        }}
                      >
                        close
                      </i>
                    )}
                  </b-alert>
                </div>
              );
            })}
          </transition-group>
        </div>
      </div>
    );
  }
}
